enum IssueType {
  Recordable = "Recordable",
  InternalDelay = "InternalDelay",
  Punch = "Punch",
  Weather = "Weather",
}

export { IssueType };
